module.exports = __webpack_public_path__ + "img/購買星座_web.62b2ff84.png";